/**
 * 图片格式识别
 */
export default class ImageDetector {
    public static isImage = (file: Blob): boolean => !!file?.type?.startsWith('image');
    public static isTIFF = (file: Blob): boolean => !!file?.type?.match(/tiff?$/i);
    public static isSVG = (file: Blob): boolean => !!file?.type?.match(/svg(\+xml)?$/i);
    public static isGif = (file: Blob): boolean => !!file?.type?.match(/gif$/i);
}
